<template>
  <div class="admin-layout">
    <!-- Sidebar -->
    <SidebarAdmin />

    <!-- Contenu principal -->
    <section class="main-content">
      <header class="page-header">
        <h2>🧪 Gestion des produits</h2>
        <p class="subtitle">Ajoutez, modifiez ou supprimez les produits du catalogue</p>
      </header>

      <!-- Barre de recherche + ajout -->
      <div class="filter-bar">
        <button class="btn-add" @click="openAddModal">+ Ajouter un produit</button>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="🔍 Rechercher un produit..."
          class="search-input"
        />
      </div>

      <!-- Tableau produits -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Catégorie</th>
              <th>Prix (MAD)</th>
              <th>Stock</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, index) in filteredProducts" :key="p._id">
              <td>{{ index + 1 }}</td>
              <td>{{ p.name }}</td>
              <td>{{ p.category }}</td>
              <td>{{ p.price.toFixed(2) }}</td>
              <td>{{ p.stock }}</td>
              <td class="action-buttons">
                <button class="btn-details" @click="editProduct(p)">Modifier</button>
                <button class="btn-delete" @click="deleteProduct(p._id)">Supprimer</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modale ajout/modif -->
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal">
          <h3>{{ editMode ? "Modifier un produit" : "Ajouter un produit" }}</h3>
          <input v-model="form.name" placeholder="Nom du produit" />
          <input v-model="form.category" placeholder="Catégorie" />
          <input v-model.number="form.price" placeholder="Prix (MAD)" type="number" />
          <input v-model.number="form.stock" placeholder="Stock disponible" type="number" />
          <div class="modal-actions">
            <button @click="saveProduct" class="btn-save">Enregistrer</button>
            <button @click="closeModal" class="btn-cancel">Annuler</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SidebarAdmin from "@/views/admin/SidebarAdmin.vue";

export default {
  name: "ProductsPage",
  components: { SidebarAdmin },
  data() {
    return {
      searchQuery: "",
      showModal: false,
      editMode: false,
      form: { _id: null, name: "", category: "", price: 0, stock: 0 },
      products: [
        { _id: "1", name: "Gants Nitrile", category: "Consommables", price: 120, stock: 150 },
        { _id: "2", name: "Microscope Binoculaire", category: "Équipements", price: 4200, stock: 10 },
        { _id: "3", name: "Réactif PCR", category: "Réactifs", price: 850, stock: 60 },
        { _id: "4", name: "Tubes à essai", category: "Matériel", price: 75, stock: 500 },
      ],
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter((p) =>
        p.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    openAddModal() {
      this.editMode = false;
      this.form = { _id: null, name: "", category: "", price: 0, stock: 0 };
      this.showModal = true;
    },
    editProduct(product) {
      this.editMode = true;
      this.form = { ...product };
      this.showModal = true;
    },
    saveProduct() {
      if (this.editMode) {
        const index = this.products.findIndex((p) => p._id === this.form._id);
        this.products.splice(index, 1, { ...this.form });
      } else {
        this.products.push({ ...this.form, _id: Date.now().toString() });
      }
      this.closeModal();
    },
    deleteProduct(id) {
      if (confirm("Supprimer ce produit ?")) {
        this.products = this.products.filter((p) => p._id !== id);
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
/* === LAYOUT === */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f4f6f9;
  font-family: "Poppins", sans-serif;
  transition: background 0.3s ease, color 0.3s ease;
}

.main-content {
  flex: 1;
  padding: 40px;
  background: #ffffff;
  border-radius: 0 16px 16px 0;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.05);
  overflow-x: hidden;
  transition: background 0.3s ease, color 0.3s ease;
}

/* === HEADER === */
.page-header {
  margin-bottom: 25px;
}
.page-header h2 {
  font-size: 24px;
  color: #00998b;
  margin-bottom: 5px;
}
.subtitle {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

/* === BARRE FILTRE === */
.filter-bar {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}
.search-input {
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.25s ease;
}
.search-input:focus {
  border-color: #00998b;
  box-shadow: 0 0 0 3px rgba(0, 153, 139, 0.15);
}
.btn-add {
  background-color: #00998b;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}
.btn-add:hover {
  background-color: #007f75;
  transform: translateY(-1px);
}

/* === TABLEAU === */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
  scrollbar-width: thin;
}
.table-wrapper::-webkit-scrollbar {
  height: 8px;
}
.table-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: background 0.3s ease;
}
th,
td {
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  text-align: left;
  font-size: 14px;
  color: #222;
  white-space: nowrap;
}
th {
  background-color: #f8f9fa;
  color: #333;
  text-transform: uppercase;
  font-weight: 600;
}

/* === ACTIONS === */
.action-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.btn-details {
  background-color: #2196f3;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-details:hover {
  background-color: #0d8bf2;
}
.btn-delete {
  background-color: #e0240b;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.btn-delete:hover {
  background-color: #b91c09;
}

/* === MODALE === */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  text-align: center;
}
.modal h3 {
  margin-bottom: 20px;
  color: #05305b;
}
.modal input {
  width: 100%;
  padding: 10px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.modal-actions {
  display: flex;
  justify-content: space-between;
}
.btn-save {
  background: #00998b;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}
.btn-cancel {
  background: #ccc;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

/* === RESPONSIVE === */
@media (max-width: 700px) {
  .admin-layout {
    flex-direction: column;
  }
  .main-content {
    padding: 25px;
    border-radius: 0;
  }
  table {
    min-width: 700px;
  }
  th,
  td {
    padding: 12px 10px;
    font-size: 13px;
  }
}
@media (max-width: 600px) {
  .filter-bar {
    flex-direction: column;
  }
  table {
    min-width: 600px;
  }
  th,
  td {
    padding: 10px 8px;
    font-size: 12px;
  }
  .action-buttons {
    flex-direction: column;
    align-items: flex-start;
  }
  .btn-details,
  .btn-delete {
    width: 100%;
    text-align: center;
  }
}

/* === MODE SOMBRE === */
@media (prefers-color-scheme: dark) {
  .admin-layout {
    background: #0f1720;
  }
  .main-content {
    background: #1a2532;
    color: #e6edf1;
  }
  .page-header h2 {
    color: #00c8b3;
  }
  .subtitle {
    color: #b0bec5;
  }
  table {
    background: #1f2b3a;
  }
  th {
    background: #253444;
    color: #e6edf1;
  }
  td {
    border-bottom: 1px solid #2e3d4d;
    color: #e1e8ed;
  }
  .search-input {
    background: #24313f;
    color: #e6edf1;
    border-color: #3a4a5b;
  }
  .search-input:focus {
    border-color: #00bfa5;
    box-shadow: 0 0 0 2px rgba(0, 191, 165, 0.3);
  }
  .btn-add,
  .btn-save {
    background-color: #00bfa5;
    color: #fff;
  }
  .btn-add:hover {
    background-color: #00a38c;
  }
  .btn-details {
    background-color: #5a5858;
  }
  .btn-delete {
    background-color: #5a5858;
  }
  .modal {
    background: #263342;
    color: #e6edf1;
  }
  .modal input {
    background: #1b2633;
    color: #e6edf1;
    border-color: #3a4a5b;
  }
}
</style>



<!--<template>
  <div class="search-container">
    <input
      type="text"
      v-model="searchQuery"
      @keyup.enter="searchProducts"
      placeholder="Rechercher un produit..."
      class="search-bar"
    />
    <i class="fas fa-search search-icon" @click="searchProducts"></i>
  </div>

  <div class="product-grid">
    <div 
      v-for="product in products" 
      :key="product._id" 
      class="product-item"
    >
      <img :src="product.image" alt="Produit" class="product-image" />
      <h3 class="product-name">{{ product.name }}</h3>
      <p class="product-price">{{ product.price }} DH</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductsPage",
  data() {
    return {
      searchQuery: "",
      products: [],
    };
  },

  methods: {
    async searchProducts() {
      try {
        const res = await axios.get(
          `http://localhost:2028/api/products?search=${this.searchQuery}`
        );
        this.products = res.data;
      } catch (error) {
        console.error("Erreur lors de la recherche :", error);
      }
    },
    async getAllProducts() {
      try {
        const res = await axios.get("http://localhost:2028/api/products");
        this.products = res.data;
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    },
  },
  mounted() {
    this.getAllProducts();
  },
};
</script>
-->